import { Component, ChangeDetectionStrategy, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { ExperienceOperatorStatus } from 'app/experience/models/operators/tour-operator-status.enum';
import { OperatorRegistration } from 'app/experience/models';
import { OperatorActionType } from 'app/shared/enums/operator-action-type.enum';
import { TourOperatorService } from 'app/services';

enum ActionBtnColor {
	Approve = '#1CBA70',
	Request = '#004060',
	Reject = '#EB1D25',
}

@Component({
	selector: 'operator-action-modal',
	templateUrl: './operator-action-modal.component.html',
	styleUrls: ['./operator-action-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class OperatorActionModalComponent implements OnInit {
	selectedAction: OperatorActionType = OperatorActionType.None;
	appliedStatus: ExperienceOperatorStatus = ExperienceOperatorStatus.None;
	loading: boolean = false;
	actionHeadText: string = '';
	actionText: string = '';
	actionBtnColor: ActionBtnColor = ActionBtnColor.Approve;
	actionBtnText: string = '';
	tourOperator: OperatorRegistration | null = null;
	OperatorActionType = OperatorActionType;

	constructor(
		private operatorsService: TourOperatorService,
		private messageService: MessageService,
		private cdr: ChangeDetectorRef,
		protected dialogRef: MatDialogRef<OperatorActionModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {	}

	ngOnInit() {
		this.selectedAction = this.data?.OperatorActionType;
		this.tourOperator = this.data?.Operator;
		this.setActionParams(this.selectedAction);
	}

	setActionParams(actionType: OperatorActionType) {
		switch (actionType) {
			case OperatorActionType.Approve:
				this.appliedStatus = ExperienceOperatorStatus.Verified;
				this.actionHeadText = 'Approve Registration';
				this.actionBtnColor = ActionBtnColor.Approve;
				this.actionBtnText = 'Approve Registration';
				break;
			case OperatorActionType.Request:
				this.appliedStatus = ExperienceOperatorStatus.Pending;
				this.actionHeadText = 'Request Revisions';
				this.actionBtnColor = ActionBtnColor.Request;
				this.actionBtnText = 'Request Revision';
				break;
			case OperatorActionType.Reject:
				this.appliedStatus = ExperienceOperatorStatus.Rejected;
				this.actionHeadText = 'Reject Registration';
				this.actionBtnColor = ActionBtnColor.Reject;
				this.actionBtnText = 'Reject and Request Revisions';
				break;
		}
	}

	applyAction() {
		this.loading = true;
		const dto = {
			OperatorId: this.tourOperator?.OperatorId,
			StatusId: this.appliedStatus,
			ActionText: this.actionText,
		};

		this.operatorsService.applyAction(dto, this.messageService)
			.then(response => {
				this.loading = false;
				this.cdr.markForCheck();
				if (!response || !response?.Success) {
					this.messageService.add({
						severity: 'error',
						summary: 'Error',
						detail: response?.ErrorMessage || 'Failed to change tour operator status'
					});
				} else {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Tour Operator status updated'});
					this.dialogRef.close(true);
				}
			})
			.catch(err => {
				this.loading = false;
				this.cdr.markForCheck();
				throw err;
			});
	}
}
